<template>
    <div>
        <b-modal
            id="m-suspect-box"
            :title="isViewMode ? 'Detail Suspect Box' : 'Input Suspect Box'"
            size="lg"
            no-close-on-backdrop
            no-close-on-esc
            hide-footer
            @hidden="clearInput"
        >
            <LoadingWidget
                v-if="initStatus != 1"
                :status="initStatus"
                @init="init"
            />
            <div v-else>
                <div v-if="isViewMode">
                    <b-row>
                        <b-col md="12">
                            <div class="font-weight-bold mb-2">
                                Video Unboxing
                            </div>
                            <div v-if="item.marked_video_url">
                                <video
                                    controls
                                    style="max-width: 100%; max-height: 400px; width: 100%;"
                                    :src="item.marked_video_url"
                                ></video>
                            </div>
                            <b-alert v-else show variant="warning">
                                Tidak ada video.
                            </b-alert>

                            <div class="font-weight-bold mt-3">Catatan</div>
                            <p class="mb-1">
                                {{ item.marked_note || "-" }}
                            </p>

                            <div class="text-muted small mt-3">
                                <span v-if="item.marked_by">
                                    Dilaporkan oleh:
                                    {{ item.marked_by.name || item.marked_by }}
                                </span>
                                <br />
                                <span v-if="item.marked_at">
                                    Waktu:
                                    {{
                                        item.marked_at
                                            ? $helper.parseDate(
                                                  item.marked_at
                                              ) +
                                              ", " +
                                              $helper.parseHourMinute(
                                                  item.marked_at
                                              )
                                            : "-"
                                    }}
                                </span>
                            </div>
                        </b-col>
                    </b-row>
                    <b-row>
                        <b-col md="12" class="mt-4 text-right">
                            <b-button
                                variant="secondary"
                                @click="$bvModal.hide('m-suspect-box')"
                            >
                                Tutup
                            </b-button>
                        </b-col>
                    </b-row>
                </div>

                <div v-else>
                    <b-row>
                        <b-col md="12">
                            <div>
                                <div class="font-weight-bold">
                                    Upload Video Unboxing
                                    <span style="color: red;">*</span>
                                </div>
                                <div v-if="!videoPreviewUrl">
                                    <b-form-file
                                        id="video-unboxing"
                                        v-model="input.videoUnboxing"
                                        accept="video/mp4, video/quicktime"
                                        placeholder="Pilih file video..."
                                        browse-text="Browse"
                                        @change="onFileChange"
                                    />
                                </div>
                                <div v-else class="mt-2">
                                    <video
                                        controls
                                        style="max-width: 100%; max-height: 300px; width: 100%;"
                                        :src="videoPreviewUrl"
                                    ></video>
                                    <b-button
                                        variant="danger"
                                        size="sm"
                                        class="mt-2"
                                        @click="clearVideo"
                                    >
                                        <i class="fa fa-trash mr-1"></i> Hapus
                                        Video
                                    </b-button>
                                </div>
                            </div>
                            <div>
                                <div class="font-weight-bold mt-3">Catatan <span style="color: red;">*</span></div>
                                <b-form-textarea
                                    id="notes"
                                    v-model="input.notes"
                                    placeholder="Masukkan catatan"
                                />
                            </div>
                        </b-col>
                    </b-row>
                    <b-row>
                        <b-col md="12" class="mt-4">
                            <div style="display:flex; justify-content: end;">
                                <b-button
                                    id="submit"
                                    variant="primary"
                                    :disabled="isSubmitting"
                                    @click="createSuspectBox()"
                                >
                                    {{
                                        isSubmitting ? "Menyimpan..." : "Simpan"
                                    }}
                                </b-button>
                            </div>
                        </b-col>
                    </b-row>
                </div>
            </div>

            <loading-overlay
                :fotoStartTime="uploadTimeStamp.startPresignedUrl"
                :fotoEndTime="uploadTimeStamp.endPresignedUrl"
                :uploadStartTime="uploadTimeStamp.startUploadToS3"
                :uploadEndTime="uploadTimeStamp.endUploadToS3"
                :penyimpananStartTime="uploadTimeStamp.startSaveFile"
                :penyimpananEndTime="uploadTimeStamp.endSaveFile"
                :show="isShowLoadingOverlay"
            />
        </b-modal>
    </div>
</template>

<script>
import LoadingOverlay from "../barang-masuk/LoadingOverlay.vue";

export default {
    name: "ModalSuspectBox",
    components: {
        LoadingOverlay
    },
    props: {
        item: {
            type: Object,
            default: () => null
        }
    },
    data() {
        return {
            initStatus: 0,
            isSubmitting: false,
            input: {
                videoUnboxing: null,
                notes: ""
            },
            uploadTimeStamp: {
                startPresignedUrl: null,
                endPresignedUrl: null,
                startUploadToS3: null,
                endUploadToS3: null,
                startSaveFile: null,
                endSaveFile: null
            },
            uploadProgress: 0,
            isShowLoadingOverlay: false,
            videoPreviewUrl: null,
            uploadedFilePath: null,
            suspectBoxDirPath: "penerimaan-box-pei/suspectbox" // supplier-specific: RBE uses "penerimaan-box-rbe/suspectbox"
        };
    },
    methods: {
        async init() {
            this.initStatus = 0;
            this.initStatus = 1;
        },

        async getPresignedUrl(fileName, fileType) {
            this.uploadTimeStamp.startPresignedUrl = this.formatTime(
                new Date()
            );
            const payload = {
                file_name: fileName,
                file_type: fileType,
                reference_key: this.item.box_code,
                directory_path: this.suspectBoxDirPath
            };
            const response = await this.$axios.post(
                "get-presigned-url",
                payload
            );
            this.uploadTimeStamp.endPresignedUrl = this.formatTime(new Date());
            return response.data.data;
        },

        async uploadToS3(file, presignedUrl) {
            this.uploadTimeStamp.startUploadToS3 = this.formatTime(new Date());
            const response = await fetch(presignedUrl, {
                method: "PUT",
                body: file,
                headers: {
                    "Content-Type": file.type
                }
            });
            if (!response.ok) throw new Error("Upload to S3 failed");
            this.uploadTimeStamp.endUploadToS3 = this.formatTime(new Date());
            return response;
        },

        async onFileChange(event) {
            const file = event.target.files[0];
            if (!file) return;

            const allowedVideoTypes = ["video/mp4", "video/quicktime"];
            const maxSize = 400 * 1024 * 1024; // 400MB

            if (!allowedVideoTypes.includes(file.type)) {
                this.$helper.toastError(
                    this,
                    `File ${
                        file.name
                    } tidak sesuai dengan tipe file yang diizinkan`
                );
                this.input.videoUnboxing = null;
                return;
            }
            if (file.size > maxSize) {
                this.$helper.toastError(
                    this,
                    "Operasi dibatalkan: ukuran file melebihi 400MB."
                );
                this.input.videoUnboxing = null;
                return;
            }

            this.isShowLoadingOverlay = true;

            try {
                const { presigned_url, file_path } = await this.getPresignedUrl(
                    file.name,
                    file.type
                );

                await this.uploadToS3(file, presigned_url);

                this.uploadTimeStamp.startSaveFile = this.formatTime(
                    new Date()
                );
                this.uploadTimeStamp.endSaveFile = this.formatTime(new Date());

                this.uploadedFilePath = `${this.suspectBoxDirPath}/${
                    this.item.box_code
                }/${file_path}`;
                this.videoPreviewUrl = URL.createObjectURL(file);

                this.$helper.toastSuccess(this, "Video berhasil diupload");
            } catch (error) {
                this.$helper.parseError(this, error);
                this.clearVideo();
            } finally {
                this.isShowLoadingOverlay = false;
                this.resetUploadTimestamp();
            }
        },

        clearVideo() {
            this.videoPreviewUrl = null;
            this.uploadedFilePath = null;
            this.input.videoUnboxing = null;
        },

        async createSuspectBox() {
            if (!this.uploadedFilePath) {
                this.$helper.toastError(this, "Upload video terlebih dahulu.");
                return;
            }

            if (!this.input.notes) {
                this.$helper.toastError(this, "Catatan wajib diisi");
                return;
            }

            if (this.isSubmitting) {
                return;
            }

            if (!this.item || !this.item.id) {
                this.$helper.toastError(
                    this,
                    "Tidak ada data Box yang dipilih."
                );
                return;
            }

            this.isSubmitting = true;
            try {
                let isConfirmed = confirm(
                    "Apakah Anda yakin akan menandai box ini sebagai Suspect Box?"
                );
                if (!isConfirmed) {
                    return;
                }

                const payload = {
                    file_path: this.uploadedFilePath,
                    notes: this.input.notes
                };
                await this.$axios.post(
                    `/gold-deliveries/box/${this.item.id}/suspect`,
                    payload
                );

                this.$helper.toastSuccess(
                    this,
                    "Box berhasil ditandai sebagai Suspect Box."
                );
                this.$emit("refresh-items");
                this.$bvModal.hide("m-suspect-box");
            } catch (error) {
                this.$helper.parseError(this, error);
            } finally {
                this.isSubmitting = false;
            }
        },
        resetUploadTimestamp() {
            this.uploadTimeStamp = {
                startPresignedUrl: null,
                endPresignedUrl: null,
                startUploadToS3: null,
                endUploadToS3: null,
                startSaveFile: null,
                endSaveFile: null
            };
        },
        clearInput() {
            this.input = {
                videoUnboxing: null,
                notes: ""
            };
            this.clearVideo();
        },

        formatTime(date) {
            const hh = String(date.getHours()).padStart(2, "0");
            const mm = String(date.getMinutes()).padStart(2, "0");
            const ss = String(date.getSeconds()).padStart(2, "0");
            return `${hh}:${mm}:${ss}`;
        }
    },
    mounted() {
        this.init();
    },
    computed: {
        isViewMode() {
            return !!(this.item && this.item.marked_video_url);
        }
    },
    watch: {
        item(newItem) {
            if (!newItem) {
                return;
            }
            this.init();
        }
    }
};
</script>
